export const getFilesTypes = (mimeTypes = {}) => {
  if (typeof mimeTypes === "object") {
    return (
      Object.keys(mimeTypes)
        ?.map((item) => mimeTypes[item]?.join(", ") || "")
        ?.join(", ") || ""
    );
  } else {
    return mimeTypes;
  }
};

export const getFileExtension = (fileName) => {
  return fileName?.split(".").pop();
};

export const getFileIcon = (fileName) => {
  const ext = getFileExtension(fileName);
  const defaultIcon = "AllDocumentTypes";
  const fileMapping = {
    ZipFile: ["zip", "7z"],
    AllImageTypes: ["png", "jpg", "jpeg", "jfif", "svg", "tiff"],
    pdf: ["pdf"],
  };
  let icon = Object.keys(fileMapping).find((map) => {
    return fileMapping[map].includes(ext.toLowerCase());
  });

  return icon || defaultIcon;
};

export const byteToSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getCapitalizeText = (str) => {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b(\w)/g, (x) => x.toUpperCase());
};

export const stringToArray = (stringValue) => {
  return stringValue.split(",");
};

export const arrayToString = (arr) => {
  return arr.join(",");
};

export const getStatusArray = (selectedStatus) => {
  return selectedStatus.length > 0 ? stringToArray(selectedStatus) : [];
};

export const isTouchDevice = () => {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

// export const getQueryString = (params, url = "") => {
//   if (typeof params !== "object" || values(params).every(isEmpty)) {
//     return url;
//   }

//   let queryString = Object.keys(params)
//     .map((key) => {
//       return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
//     })
//     .join("&");
//   return queryString ? url + "?" + queryString : url;
// };

export const arrayInsertAt = (arr = [], index, newItem) => {
  return [...arr.slice(0, index), newItem, ...arr.slice(index)];
};

export const isMacSafariBrowser = () => {
  const platformExpression = /Mac/i;
  const rejectedExpression = /Chrome|Android|CriOS|FxiOS|EdgiOS/i;
  const expectedExpression = /Safari/i;

  const agent = navigator.userAgent;
  if (rejectedExpression.test(agent)) {
    return false;
  }
  return platformExpression.test(agent) && expectedExpression.test(agent);
};

export const getColumnsForTable = (data, subRowKey) => {
  const dynamicColumns = Object.keys(data[0])
    .filter(
      (key) =>
        key.toLowerCase() !== subRowKey.toLowerCase() &&
        key.toLowerCase() !== "id"
    )
    .map((key) => ({
      accessorKey: key,
      header: key.toUpperCase(),
    }));

  return dynamicColumns;
};

export const isRoleAllowed = (userRole, allowedRoles = []) => {
  if (!userRole) return false;

  const userRolesArray = Array.isArray(userRole) ? userRole : [userRole];
  const allowedRolesArray = Array.isArray(allowedRoles)
    ? allowedRoles
    : [allowedRoles];

  return userRolesArray.some((role) => allowedRolesArray.includes(role));
};

export const cleanOverEscapedText = (text) => {
  return text
    .replace(/'{2,}/g, "'") // Fix over-escaped single quotes (e.g., '''''' → ')
    .replace(/"{2,}/g, '"') // Fix over-escaped double quotes (if any)
    .replace(/(\w)["`′]{1,2}s\b/g, "$1's") // Fix malformed apostrophes like let"s
    .replace(/href=['"]{2,}(.*?)['"]{2,}/g, 'href="$1"') // Fix anchor href quotes
    .replace(/target=['"]{2,}(.*?)['"]{2,}/g, 'target="$1"')
    .replace(/rel=['"]{2,}(.*?)['"]{2,}/g, 'rel="$1"');
};

export const getFormattedDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate =
    `${String(date.getMonth() + 1).padStart(2, "0")}/` +
    `${String(date.getDate()).padStart(2, "0")}/` +
    `${date.getFullYear()}`;
  return formattedDate;
};

export const downloadFile = (str, filename) => {
  // 2. Create a Blob object
  const utf8BOM = "\uFEFF";
  const content = utf8BOM + str;
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
 
  // 3. Create a temporary URL
  const url = URL.createObjectURL(blob);
 
  // 4. Create a temporary link and simulate a click
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
 
  // Append to body, click, and remove
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
 
  // Release the object URL
  URL.revokeObjectURL(url);
}
